import { render, staticRenderFns } from "./DlvES_Delivery_Details.vue?vue&type=template&id=6fbdb4f2"
import script from "./DlvES_Delivery_Details.vue?vue&type=script&lang=js"
export * from "./DlvES_Delivery_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports